/**
 * Internal dependencies
 */
import { Link } from 'types';

export const linkToButtonProps = (link: Link) => ({
	children: link.label,
	to: link.url,
});
